(function () {
  const BREAKPOINT = 768; // <768 traktujemy jako mobile
  const mql = window.matchMedia(`screen and (max-width: ${BREAKPOINT}px)`);
  let wasMobile = mql.matches;

  // wybór adresu obrazka z data-src-*
  function pickSrc(img) {
    if (mql.matches) {
      return img.dataset.srcMobile || img.dataset.src || img.getAttribute("src");
    }
    return img.dataset.srcDesktop || img.dataset.src || img.getAttribute("src");
  }

  // sprawdzanie czy element jest w viewport
  function isInViewport(el) {
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const vw = window.innerWidth || document.documentElement.clientWidth;
    return r.top < vh && r.bottom > 0 && r.left < vw && r.right > 0;
  }

  // podmień src obrazka z logiem, fade i fallbackiem
  function applySrc(el) {
    let target = pickSrc(el);
    if (!target) return;

    // mixed-content fix
    if (location.protocol === "https:" && target.startsWith("http:")) {
      target = target.replace(/^http:/, "https:");
    }

    const current = el.getAttribute("src") || "";
    if (current === target) return;

    console.debug("[img-swap]", { current, target, mobile: mql.matches });

    el.style.transition = "opacity 450ms";
    el.style.opacity = "0.9";

    const onLoad = () => {
      el.style.opacity = "1";
      el.removeEventListener("load", onLoad);
      el.removeEventListener("error", onError);
    };

    const onError = () => {
      console.warn("[img-swap] load error → fallback", { tried: target });
      const fallback = mql.matches
        ? el.dataset.srcDesktop || current
        : el.dataset.srcMobile || current;
      if (fallback && fallback !== target) {
        el.setAttribute("src", fallback);
      } else {
        el.setAttribute("src", current);
      }
      el.style.opacity = "1";
      el.removeEventListener("load", onLoad);
      el.removeEventListener("error", onError);
    };

    el.addEventListener("load", onLoad);
    el.addEventListener("error", onError);

    el.setAttribute("src", target);
  }

  // załaduj obrazek i oznacz jako preloaded
  function loadImg(el, observer) {
    applySrc(el);
    el.classList.remove("__js_preload");
    el.classList.add("__js_preloaded");
    if (observer) observer.unobserve(el);
  }

  // IntersectionObserver – lazy load
  const io = new IntersectionObserver(function (entries, obs) {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      if (entry.isIntersecting) loadImg(entry.target, obs);
    }
  });

  // podłącz istniejące obrazki
  document.querySelectorAll("img.__js_preload").forEach(function (el) {
    if (isInViewport(el)) loadImg(el, io);
    else io.observe(el);
  });

  // MutationObserver – obsługa nowych elementów
  const mo = new MutationObserver(function (mutations) {
    for (let i = 0; i < mutations.length; i++) {
      const m = mutations[i];
      m.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches("img.__js_preload")) {
          if (isInViewport(node)) loadImg(node, io);
          else io.observe(node);
        }
        if (typeof node.querySelectorAll === "function") {
          node.querySelectorAll("img.__js_preload").forEach(function (el) {
            if (isInViewport(el)) loadImg(el, io);
            else io.observe(el);
          });
        }
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // sprawdź i odśwież widoczne obrazki
  function refreshVisible() {
    document.querySelectorAll("img.__js_preload").forEach(function (el) {
      if (isInViewport(el)) loadImg(el, io);
    });
    document.querySelectorAll("img.__js_preloaded").forEach(function (el) {
      if (isInViewport(el)) applySrc(el);
    });
  }

  // zmiana media query
  mql.addEventListener("change", function () {
    wasMobile = mql.matches;
    refreshVisible();
  });

  // debounce helper
  function debounce(fn, delay = 150) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, delay);
    };
  }

  // resize – odśwież tylko gdy przekroczono breakpoint
  window.addEventListener(
    "resize",
    debounce(function () {
      const nowMobile = window.innerWidth < BREAKPOINT;
      if (nowMobile !== wasMobile) {
        wasMobile = nowMobile;
        refreshVisible();
      }
    }, 150)
  );
})();